import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerOrdiniDaClienteModalComponent} from './worker-ordini-da-cliente-modal';

export const WorkerOrdiniDaClienteModalModule: string = ng
    .module('worker-ordini_da_cliente-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerOrdiniDaClienteModalComponent', WorkerOrdiniDaClienteModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-ordini-da-cliente-modal/worker-ordini-da-cliente-modal.module.ts